import moment from 'moment-timezone'

const formatDateTime = (date, format = 'DD-MM-YYYY HH:mm') => {
  if (!date) return ''

  let validDate = null

  // Si es un número (epoch en segundos)
  if (typeof date === 'number') {
    validDate = moment.unix(date)
  }
  // Si es una instancia de Date
  else if (date instanceof Date) {
    validDate = moment(date)
  }
  // Si es un objeto Moment
  else if (moment.isMoment(date)) {
    validDate = date
  } else {
    // Forzar a string para evitar errores con .match
    const dateStr = String(date)

    // Corrige si tiene horas como "13:06 PM" → "1:06 PM"
    const regex = /(\d{2}):(\d{2})\s?(PM|AM)/i
    const match = dateStr.match(regex)
    let cleanDate = dateStr

    if (match && parseInt(match[1], 10) > 12) {
      const hours = parseInt(match[1], 10) - 12
      const newTime = `${hours}:${match[2]} ${match[3]}`
      cleanDate = dateStr.replace(regex, newTime)
    }

    // Formatos permitidos
    const formats = [
      moment.ISO_8601,
      'YYYY-MM-DD',
      'YYYY/MM/DD',
      'YYYY-MM-DDTHH:mm:ss.SSSZ',
      'MMM D, YYYY, h:mm A',
      'DD-MM-YYYY HH:mm:ss',
      'MM-DD-YYYY HH:mm:ss',
      'YYYY-MM-DD HH:mm:ss',
      'YYYY-MM-DD HH:mm',
      'MMMM D, YYYY, h:mm A'
    ]

    for (const fmt of formats) {
      const parsed = moment(cleanDate, fmt, true)
      if (parsed.isValid()) {
        validDate = parsed
        break
      }
    }
  }

  if (!validDate || !validDate.isValid()) {
    return 'Invalid date'
  }

  return validDate.tz('America/Mexico_City').format(format)
}

export { formatDateTime }
